export const normalizeNameSearchTag = (raw: string): string =>
    raw.trim().replace(/\s+/g, ' ');

export const nameSearchTagsEqual = (left: string, right: string): boolean =>
    normalizeNameSearchTag(left).toLowerCase() ===
    normalizeNameSearchTag(right).toLowerCase();
